/* Product page launch countdown (<zl-launch-countdown>, snippets/zl-launch-countdown.liquid).

   The server renders the first values; this keeps them current:
   - boxes: days / hours / minutes left until data-end;
   - bar: how far we are from data-start to data-end.

   Performance: one timer per countdown, fired on the next minute boundary
   (the smallest unit shown), not every second. Stopped while the tab is hidden
   and when the element leaves the page; picks up the right time on return. */
(function () {
  if (!window.customElements || customElements.get('zl-launch-countdown')) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  class ZlLaunchCountdown extends HTMLElement {
    connectedCallback() {
      this.end = (parseInt(this.dataset.end, 10) || 0) * 1000;
      this.start = (parseInt(this.dataset.start, 10) || 0) * 1000;
      this.minProgress = parseFloat(this.dataset.minProgress) || 0;
      if (!this.end) return;

      this.days = this.querySelector('[data-zl-launch-days]');
      this.hours = this.querySelector('[data-zl-launch-hours]');
      this.mins = this.querySelector('[data-zl-launch-mins]');
      this.bar = this.querySelector('[data-zl-launch-bar]');
      this.timer = this.querySelector('[data-zl-launch-timer]');
      this.done = this.querySelector('[data-zl-launch-done]');

      this.onVisibility = this.onVisibility.bind(this);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.tick();
    }

    disconnectedCallback() {
      clearTimeout(this._t);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    onVisibility() {
      if (document.hidden) clearTimeout(this._t);
      else this.tick();
    }

    tick() {
      clearTimeout(this._t);
      var now = Date.now();
      var left = Math.max(0, this.end - now);

      if (left <= 0) {
        this.finish();
        return;
      }

      var mins = Math.floor(left / 60000);
      this.set(this.days, pad(Math.floor(mins / 1440)));
      this.set(this.hours, pad(Math.floor(mins / 60) % 24));
      this.set(this.mins, pad(mins % 60));

      if (this.bar && this.start && this.end > this.start) {
        var pct = ((now - this.start) / (this.end - this.start)) * 100;
        pct = Math.min(100, Math.max(this.minProgress, pct));
        this.style.setProperty('--zl-launch-progress', pct.toFixed(2) + '%');
        this.bar.setAttribute('aria-valuenow', String(Math.round(pct)));
      }

      /* Next update exactly when the minute on screen changes. */
      var wait = (left % 60000) || 60000;
      var self = this;
      this._t = setTimeout(function () { self.tick(); }, wait + 50);
    }

    set(node, text) {
      if (node && node.textContent !== text) node.textContent = text;
    }

    finish() {
      if (this.dataset.hideAfter === 'true') {
        this.hidden = true;
        return;
      }
      this.classList.add('is-launched');
      this.style.setProperty('--zl-launch-progress', '100%');
      if (this.timer) this.timer.hidden = true;
      if (this.done) this.done.hidden = false;
    }
  }

  customElements.define('zl-launch-countdown', ZlLaunchCountdown);
})();
